/**
 * Costa Rica - Provincias, Cantones y Distritos
 * Códigos oficiales según INEC
 */

export const provincias = {
  '1': 'San José',
  '2': 'Alajuela',
  '3': 'Cartago',
  '4': 'Heredia',
  '5': 'Guanacaste',
  '6': 'Puntarenas',
  '7': 'Limón'
};

// Cantones por provincia (código provincia + código cantón)
export const cantones = {
  // San José
  '101': 'San José', '102': 'Escazú', '103': 'Desamparados', '104': 'Puriscal',
  '105': 'Tarrazú', '106': 'Aserrí', '107': 'Mora', '108': 'Goicoechea',
  '109': 'Santa Ana', '110': 'Alajuelita', '111': 'Vázquez de Coronado',
  '112': 'Acosta', '113': 'Tibás', '114': 'Moravia', '115': 'Montes de Oca',
  '116': 'Turrubares', '117': 'Dota', '118': 'Curridabat', '119': 'Pérez Zeledón',
  '120': 'León Cortés Castro',

  // Alajuela
  '201': 'Alajuela', '202': 'San Ramón', '203': 'Grecia', '204': 'San Mateo',
  '205': 'Atenas', '206': 'Naranjo', '207': 'Palmares', '208': 'Poás',
  '209': 'Orotina', '210': 'San Carlos', '211': 'Zarcero', '212': 'Sarchí',
  '213': 'Upala', '214': 'Los Chiles', '215': 'Guatuso', '216': 'Río Cuarto',

  // Cartago
  '301': 'Cartago', '302': 'Paraíso', '303': 'La Unión', '304': 'Jiménez',
  '305': 'Turrialba', '306': 'Alvarado', '307': 'Oreamuno', '308': 'El Guarco',

  // Heredia
  '401': 'Heredia', '402': 'Barva', '403': 'Santo Domingo', '404': 'Santa Bárbara',
  '405': 'San Rafael', '406': 'San Isidro', '407': 'Belén', '408': 'Flores',
  '409': 'San Pablo', '410': 'Sarapiquí',

  // Guanacaste
  '501': 'Liberia', '502': 'Nicoya', '503': 'Santa Cruz', '504': 'Bagaces',
  '505': 'Carrillo', '506': 'Cañas', '507': 'Abangares', '508': 'Tilarán',
  '509': 'Nandayure', '510': 'La Cruz', '511': 'Hojancha',

  // Puntarenas
  '601': 'Puntarenas', '602': 'Esparza', '603': 'Buenos Aires', '604': 'Montes de Oro',
  '605': 'Osa', '606': 'Quepos', '607': 'Golfito', '608': 'Coto Brus',
  '609': 'Parrita', '610': 'Corredores', '611': 'Garabito',

  // Limón
  '701': 'Limón', '702': 'Pococí', '703': 'Siquirres', '704': 'Talamanca',
  '705': 'Matina', '706': 'Guácimo'
};

// Catálogo completo de distritos de Costa Rica (470 distritos)
export const distritos = {
  '10101': 'Carmen',
  '10102': 'Merced',
  '10103': 'Hospital',
  '10104': 'Catedral',
  '10105': 'Zapote',
  '10106': 'San Francisco De Dos Rios',
  '10107': 'Uruca',
  '10108': 'Mata Redonda',
  '10109': 'Pavas',
  '10110': 'Hatillo',
  '10111': 'San Sebastián',
  '10201': 'Escazú',
  '10202': 'San Antonio',
  '10203': 'San Rafael',
  '10301': 'Desamparados',
  '10302': 'San Miguel',
  '10303': 'San Juan De Dios',
  '10304': 'San Rafael Arriba',
  '10305': 'San Rafael Abajo',
  '10306': 'San Antonio',
  '10307': 'Frailes',
  '10308': 'Patarra',
  '10309': 'San Cristobal',
  '10310': 'Rosario',
  '10311': 'Damas',
  '10312': 'Gravilias',
  '10313': 'Los Guido',
  '10401': 'Santiago',
  '10402': 'Mercedes Sur',
  '10403': 'Barbacoas',
  '10404': 'Grifo Alto',
  '10405': 'San Rafael',
  '10406': 'Candelarita',
  '10407': 'Desamparaditos',
  '10408': 'San Antonio',
  '10409': 'Chires',
  '10501': 'San Marcos',
  '10502': 'San Lorenzo',
  '10503': 'San Carlos',
  '10601': 'Aserrí',
  '10602': 'Tarbaca',
  '10603': 'Vuelta De Jorco',
  '10604': 'San Gabriel',
  '10605': 'Lengua',
  '10606': 'Monterrey',
  '10607': 'Salitrillos',
  '10701': 'Colón',
  '10702': 'Guayabo',
  '10703': 'Tabarcia',
  '10704': 'Piedras Negras',
  '10705': 'Picagres',
  '10801': 'Guadalupe',
  '10802': 'San Francisco',
  '10803': 'Calle Blancos',
  '10804': 'Mata De Platano',
  '10805': 'Ipís',
  '10806': 'Rancho Redondo',
  '10807': 'Purral',
  '10901': 'Santa Ana',
  '10902': 'Salitral',
  '10903': 'Pozos',
  '10904': 'Uruca',
  '10905': 'Piedades',
  '10906': 'Brasil',
  '11001': 'Alajuelita',
  '11002': 'San Josecito',
  '11003': 'San Antonio',
  '11004': 'Concepción',
  '11005': 'San Felipe',
  '11101': 'San Isidro',
  '11102': 'San Rafael',
  '11103': 'Dulce Nombre De Jesus',
  '11104': 'Patalillo',
  '11105': 'Cascajal',
  '11201': 'San Ignacio',
  '11202': 'Guaitil',
  '11203': 'Palmichal',
  '11204': 'Cangrejal',
  '11205': 'Sabanillas',
  '11301': 'San Juan',
  '11302': 'Cinco Esquinas',
  '11303': 'Anselmo Llorente',
  '11304': 'Leon Xiii',
  '11305': 'Colima',
  '11401': 'San Vicente',
  '11402': 'San Jeronimo',
  '11403': 'La Trinidad',
  '11501': 'San Pedro',
  '11502': 'Sabanilla',
  '11503': 'Mercedes',
  '11504': 'San Rafael',
  '11601': 'San Pablo',
  '11602': 'San Pedro',
  '11603': 'San Juan De Mata',
  '11604': 'San Luis',
  '11605': 'Carrara',
  '11701': 'Santa María',
  '11702': 'Jardin',
  '11703': 'Copey',
  '11801': 'Curridabat',
  '11802': 'Granadilla',
  '11803': 'Sanchez',
  '11804': 'Tirrases',
  '11901': 'San Isidro',
  '11902': 'El General',
  '11903': 'Daniel Flores',
  '11904': 'Rivas',
  '11905': 'San Pedro',
  '11906': 'Platanares',
  '11907': 'Pejibaye',
  '11908': 'Cajon',
  '11909': 'Baru',
  '11910': 'Rio Nuevo',
  '11911': 'Páramo',
  '12001': 'San Pablo',
  '12002': 'San Andres',
  '12003': 'Llano Bonito',
  '12004': 'San Isidro',
  '12005': 'Santa Cruz',
  '12006': 'San Antonio',
  '20101': 'Alajuela',
  '20102': 'San José',
  '20103': 'Carrizal',
  '20104': 'San Antonio',
  '20105': 'Guácima',
  '20106': 'San Isidro',
  '20107': 'Subanilla',
  '20108': 'San Rafael',
  '20109': 'Rio Segundo',
  '20110': 'Desamparados',
  '20111': 'Turrucares',
  '20112': 'Tambor',
  '20113': 'Garita',
  '20114': 'Sarapiquí',
  '20201': 'San Ramón',
  '20202': 'Santiago',
  '20203': 'San Juan',
  '20204': 'Piedades Norte',
  '20205': 'Piedades Sur',
  '20206': 'San Rafael',
  '20207': 'San Isidro',
  '20208': 'Angeles',
  '20209': 'Alfaro',
  '20210': 'Volio',
  '20211': 'Concepción',
  '20212': 'Zapotal',
  '20213': 'Peñas Blancas',
  '20301': 'Grecia',
  '20302': 'San Isidro',
  '20303': 'San José',
  '20304': 'San Roque',
  '20305': 'Tacares',
  '20306': 'Rio Cuarto',
  '20307': 'Puente De Piedra',
  '20308': 'Bolivar',
  '20401': 'San Mateo',
  '20402': 'Desmonte',
  '20403': 'Jesús María',
  '20501': 'Atenas',
  '20502': 'Jesús',
  '20503': 'Mercedes',
  '20504': 'San Isidro',
  '20505': 'Concepción',
  '20506': 'San José',
  '20507': 'Santa Eulalia',
  '20508': 'Escobal',
  '20601': 'Naranjo',
  '20602': 'San Miguel',
  '20603': 'San José',
  '20604': 'Cirrí Sur',
  '20605': 'San Jerónimo',
  '20606': 'San Juan',
  '20607': 'Rosario',
  '20701': 'Palmares',
  '20702': 'Zaragoza',
  '20703': 'Buenos Aires',
  '20704': 'Santiago',
  '20705': 'Candelaria',
  '20706': 'Esquipulas',
  '20707': 'La Granja',
  '20801': 'San Pedro',
  '20802': 'San Juan',
  '20803': 'San Rafael',
  '20804': 'Carrillos',
  '20805': 'Sabana Redonda',
  '20901': 'Orotina',
  '20902': 'El Mastate',
  '20903': 'Hacienda Vieja',
  '20904': 'Coyolar',
  '20905': 'La Ceiba',
  '21001': 'Quesada',
  '21002': 'Florencia',
  '21003': 'Buenavista',
  '21004': 'Aguas Zarcas',
  '21005': 'Venecia',
  '21006': 'Pital',
  '21007': 'La Fortuna',
  '21008': 'La Tigra',
  '21009': 'La Palmera',
  '21010': 'Venado',
  '21011': 'Cutris',
  '21012': 'Monterrey',
  '21013': 'Pocosol',
  '21101': 'Zarcero',
  '21102': 'Laguna',
  '21103': 'Tapesco',
  '21104': 'Guadalupe',
  '21105': 'Palmira',
  '21106': 'Zapote',
  '21107': 'Brisas',
  '21201': 'Sarchí Norte',
  '21202': 'Sarchí Sur',
  '21203': 'Toro Amarillo',
  '21204': 'San Pedro',
  '21205': 'Rodriguez',
  '21301': 'Upala',
  '21302': 'Aguas Claras',
  '21303': 'San José o Pizote',
  '21304': 'Bijagua',
  '21305': 'Delicias',
  '21306': 'Dos Rios',
  '21307': 'Yolillal',
  '21401': 'Los Chiles',
  '21402': 'Caño Negro',
  '21403': 'El Amparo',
  '21404': 'San Jorge',
  '21501': 'San Rafael',
  '21502': 'Buenavista',
  '21503': 'Cote',
  '30101': 'Oriental',
  '30102': 'Occidental',
  '30103': 'Carmen',
  '30104': 'San Nicolás',
  '30105': 'Aguacaliente (San Francisco)',
  '30106': 'Guadalupe (Arenilla)',
  '30107': 'Corralillo',
  '30108': 'Tierra Blanca',
  '30109': 'Dulce Nombre',
  '30110': 'Llano Grande',
  '30111': 'Quebradilla',
  '30201': 'Paraiso',
  '30202': 'Santiago',
  '30203': 'Orosi',
  '30204': 'Chachí',
  '30205': 'Llanos de Santa Lucía',
  '30301': 'Tres Rios',
  '30302': 'San Diego',
  '30303': 'San Juan',
  '30304': 'San Rafael',
  '30305': 'Concepción',
  '30306': 'Dulce Nombre',
  '30307': 'San Ramón',
  '30308': 'Rio Azul',
  '30401': 'Juan Viñas',
  '30402': 'Tucurrique',
  '30403': 'Pejibaye',
  '30501': 'Turrialba',
  '30502': 'La Suiza',
  '30503': 'Peralta',
  '30504': 'Santa Cruz',
  '30505': 'Santa Teresita',
  '30506': 'Pavones',
  '30507': 'Tuis',
  '30508': 'Tayutic',
  '30509': 'Santa Rosa',
  '30510': 'Tres Equis',
  '30511': 'La Isabel',
  '30512': 'Chirripó',
  '30601': 'Pacayas',
  '30602': 'Cervantes',
  '30603': 'Capellades',
  '30701': 'San Rafael',
  '30702': 'Cot',
  '30703': 'Potrero Cerrado',
  '30704': 'Cipreses',
  '30705': 'Santa Rosa',
  '30801': 'El Tejar',
  '30802': 'San Isidro',
  '30803': 'Tobosi',
  '30804': 'Patio De Agua',
  '40101': 'Heredia',
  '40102': 'Mercedes',
  '40103': 'San Francisco',
  '40104': 'Ulloa',
  '40105': 'Varablanca',
  '40201': 'Barva',
  '40202': 'San Pedro',
  '40203': 'San Pablo',
  '40204': 'Santa Roque',
  '40205': 'Santa Lucía',
  '40206': 'San José de la Montaña',
  '40301': 'Santo Domingo',
  '40302': 'San Vicente',
  '40303': 'San Miguel',
  '40304': 'Paracito',
  '40305': 'Santo Tomás',
  '40306': 'Santa Rosa',
  '40307': 'Tures',
  '40308': 'Para',
  '40401': 'Santa Bárbara',
  '40402': 'San Pedro',
  '40403': 'San Juan',
  '40404': 'Jesús',
  '40405': 'Santo Domingo',
  '40406': 'Puraba',
  '40501': 'San Rafael',
  '40502': 'San Josecito',
  '40503': 'Santiago',
  '40504': 'Los Angeles',
  '40505': 'Concepcion',
  '40601': 'San Isidro',
  '40602': 'San José',
  '40603': 'Concepción',
  '40604': 'San Francisco',
  '40701': 'San Antonio',
  '40702': 'La Ribera',
  '40703': 'La asunción',
  '40801': 'San Joaquín',
  '40802': 'Barrantes',
  '40803': 'Llorente',
  '40901': 'San Pablo',
  '41001': 'Puerto Viejo',
  '41002': 'La Virgen',
  '41003': 'Las Horquestas',
  '41004': 'Llanura Del Gaspar',
  '41005': 'Cureña',
  '50101': 'Liberia',
  '50102': 'Cañas Dulces',
  '50103': 'Mayorga',
  '50104': 'Nacascolo',
  '50105': 'Curubande',
  '50201': 'Nicoya',
  '50202': 'Mansión',
  '50203': 'San Antonio',
  '50204': 'Quebrada Honda',
  '50205': 'Sámara',
  '50206': 'Nosara',
  '50207': 'Belén De Nosarita',
  '50301': 'Santa Cruz',
  '50302': 'Bolson',
  '50303': 'Veintisiete De Abril',
  '50304': 'Tempate',
  '50305': 'Cartagena',
  '50306': 'Cuajiniquil',
  '50307': 'Diria',
  '50308': 'Cabo Velas',
  '50309': 'Tamarindo',
  '50401': 'Bagaces',
  '50402': 'La Fortuna',
  '50403': 'Mogote',
  '50404': 'Rio Naranjo',
  '50501': 'Filadelfia',
  '50502': 'Palmira',
  '50503': 'Sardinal',
  '50504': 'Belen',
  '50601': 'Cañas',
  '50602': 'Palmira',
  '50603': 'San Miguel',
  '50604': 'Bebedero',
  '50605': 'Porozal',
  '50701': 'Juntas',
  '50702': 'Sierra',
  '50703': 'San Juan',
  '50704': 'Colorado',
  '50801': 'Tilarán',
  '50802': 'Quebrada Grande',
  '50803': 'Tronadora',
  '50804': 'Santa Rosa',
  '50805': 'Líbano',
  '50806': 'Tierras Morenas',
  '50807': 'Arenal',
  '50901': 'Carmona',
  '50902': 'Santa Rita',
  '50903': 'Zapotal',
  '50904': 'San Pablo',
  '50905': 'Porvenir',
  '50906': 'Bejuco',
  '51001': 'La Cruz',
  '51002': 'Santa Cecilia',
  '51003': 'La Garita',
  '51004': 'Santa Elena',
  '51101': 'Hojancha',
  '51102': 'Monte Romo',
  '51103': 'Puerto Carrillo',
  '51104': 'Huacas',
  '60101': 'Puntarenas',
  '60102': 'Pitahaya',
  '60103': 'Chomes',
  '60104': 'Lepanto',
  '60105': 'Paquera',
  '60106': 'Manzanillo',
  '60107': 'Guacimal',
  '60108': 'Barranca',
  '60109': 'Monte Verde',
  '60110': 'Isla Del Coco',
  '60111': 'Cóbano',
  '60112': 'Chacarita',
  '60113': 'Chira',
  '60114': 'Acapulco',
  '60115': 'El Roble',
  '60116': 'Arancibia',
  '60201': 'Espíritu Santo',
  '60202': 'San Juan Grande',
  '60203': 'Macacona',
  '60204': 'San Rafael',
  '60205': 'San Jerónimo',
  '60301': 'Buenos Aires',
  '60302': 'Volcán',
  '60303': 'Potrero Grande',
  '60304': 'Boruca',
  '60305': 'Pilas',
  '60306': 'Colinas',
  '60307': 'Changuena',
  '60308': 'Biolley',
  '60309': 'Brunka',
  '60401': 'Miramar',
  '60402': 'La Unión',
  '60403': 'San Isidro',
  '60501': 'Puerto Cortés',
  '60502': 'Palmar',
  '60503': 'Sierpe',
  '60504': 'Bahía Ballena',
  '60505': 'Piedras Blancas',
  '60601': 'Quepos',
  '60602': 'Savegre',
  '60603': 'Naranjito',
  '60701': 'Golfito',
  '60702': 'Puerto Jiménez',
  '60703': 'Guaycara',
  '60704': 'Pavón',
  '60801': 'San Vito',
  '60802': 'Sabalito',
  '60803': 'Aguabuena',
  '60804': 'Limoncito',
  '60805': 'Pittier',
  '60901': 'Parrita',
  '61001': 'Corredor',
  '61002': 'La Cuesta',
  '61003': 'Canoas',
  '61004': 'Laurel',
  '61101': 'Jacó',
  '61102': 'Tárcoles',
  '70101': 'Limón',
  '70102': 'Valle La Estrella',
  '70103': 'Rio Blanco',
  '70104': 'Matama',
  '70201': 'Guapiles',
  '70202': 'Jiménez',
  '70203': 'Rita',
  '70204': 'Roxana',
  '70205': 'Cariari',
  '70206': 'Colorado',
  '70301': 'Siquirres',
  '70302': 'Pacuarito',
  '70303': 'Florida',
  '70304': 'Germania',
  '70305': 'El Cairo',
  '70306': 'Alegría',
  '70401': 'Bratsi',
  '70402': 'Sixaola',
  '70403': 'Cahuita',
  '70404': 'Telire',
  '70501': 'Matina',
  '70502': 'Batán',
  '70503': 'Carrandi',
  '70601': 'Guácimo',
  '70602': 'Mercedes',
  '70603': 'Pocora',
  '70604': 'Rio Jiménez',
  '70605': 'Duacari'
}

/**
 * Get provincia name from code
 */
export function getProvinciaNombre(codigo) {
  if (!codigo) return '';
  return provincias[codigo.toString()] || codigo;
}

/**
 * Get canton name from codes
 */
export function getCantonNombre(provincia, canton) {
  if (!provincia || !canton) return '';
  const key = `${provincia}${canton.toString().padStart(2, '0')}`;
  return cantones[key] || canton;
}

/**
 * Get distrito name from codes
 */
export function getDistritoNombre(provincia, canton, distrito) {
  if (!provincia || !canton || !distrito) return '';
  const key = `${provincia}${canton.toString().padStart(2, '0')}${distrito.toString().padStart(2, '0')}`;
  return distritos[key] || distrito;
}

/**
 * Get full location string
 */
export function getUbicacionCompleta(provincia, canton, distrito) {
  const parts = [];

  if (distrito && provincia && canton) {
    const distritoNombre = getDistritoNombre(provincia, canton, distrito);
    if (distritoNombre) parts.push(distritoNombre);
  }

  if (canton && provincia) {
    const cantonNombre = getCantonNombre(provincia, canton);
    if (cantonNombre) parts.push(cantonNombre);
  }

  if (provincia) {
    const provinciaNombre = getProvinciaNombre(provincia);
    if (provinciaNombre) parts.push(provinciaNombre);
  }

  return parts.join(', ');
}

/**
 * Get list of provincias for dropdown
 */
export function getProvinciasOptions() {
  return Object.entries(provincias).map(([value, label]) => ({ value, label }));
}

/**
 * Get cantones for a specific provincia
 */
export function getCantonesOptions(provinciaCode) {
  if (!provinciaCode) return [];
  const options = [];
  Object.entries(cantones).forEach(([key, label]) => {
    if (key.startsWith(provinciaCode.toString())) {
      const cantonCode = key.slice(-2);
      options.push({ value: cantonCode, label });
    }
  });
  return options;
}

/**
 * Get distritos for a specific provincia and canton
 */
export function getDistritosOptions(provinciaCode, cantonCode) {
  if (!provinciaCode || !cantonCode) return [];
  const prefix = `${provinciaCode}${cantonCode.toString().padStart(2, '0')}`;
  const options = [];
  Object.entries(distritos).forEach(([key, label]) => {
    if (key.startsWith(prefix)) {
      const distritoCode = key.slice(-2);
      options.push({ value: distritoCode, label });
    }
  });
  return options;
}
